export default __webpack_public_path__ + "static/media/6.21623a4f.jpg";